module.exports = __webpack_public_path__ + "static/media/google-podcast.7413392a.svg";